<template>
  <router-link
    :to="url"
    v-if="!newWindow"
    tabindex="0"
    class="library-card-link"
  >
    <div class="library-card">
      <div class="library-card__body">
        <slot/>
      </div>
      <div class="library-card__footer">
        <template v-if="showTimestamp">
          <div class="bottom-left">
            <i class="fa fa-calendar" aria-hidden="true"/>
            <span>Updated {{ updatedTimeAgo }}</span>
          </div>
        </template>
        <div class="bottom-right">
          <slot name="footer-right"/>
        </div>
      </div>
    </div>
  </router-link>
  <router-link
    :to="url"
    v-else-if="newWindow"
    v-slot="{ href }">
    <a
      :href="href"
      target="_blank"
      class="library-card-link"
    >
      <div class="library-card">
        <div class="library-card__body">
          <slot/>
        </div>
        <div class="library-card__footer">
          <template v-if="showTimestamp">
            <div class="bottom-left">
              <i class="fa fa-calendar" aria-hidden="true"/>
              <span>Updated {{ updatedTimeAgo }}</span>
            </div>
          </template>
          <div class="bottom-right">
            <slot name="footer-right"/>
          </div>
        </div>
      </div>
    </a>
  </router-link>
</template>

<script>
import { savedWhen } from '@/util/time'

export default {
  name: 'LibraryCard',
  data() {
    return {}
  },
  props: {
    url: {
      type: [String, Object],
      required: true,
      validate: function(value) {
        if (typeof value !== 'string' && value.keys !== undefined) {
          let fields = value.keys()
          if (fields.indexOf('name') < 0 || fields.indexOf('params') < 0) {
            return false
          }
        }
        return true
      }
    },
    updatedTime: {
      type: String,
      required: true
    },
    internalLink: {
      type: Boolean,
      default: false
    },
    newWindow: {
      type: Boolean,
      default: false
    },
    showTimestamp: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    updatedTimeAgo() {
      return savedWhen(this.updatedTime)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';

.library-card {
  .paper-card;
  position: relative;
  background-color: #fafafa;
  margin-bottom: 15px;

  &:hover {
    background-color: #fffddd;
  }
}
a {
  text-decoration: none;
  color: inherit;
  display: block;
  &:hover,
  &:focus {
    text-decoration: none;
    color: inherit;
  }
}
.library-card__footer {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 8px 16px;
  font-size: 12px;
  line-height: 20px;
  border: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}
.bottom-left {
  display: flex;
  align-items: center;
  gap: 4px;
}
.bottom-right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.focus-styles {
  outline-offset: 1px;
}
.library-card-link:focus-visible {
  .focus-styles;
}
@supports not selector(:focus-visible) {
  .library-card-link:focus {
    .focus-styles;
  }
}
</style>
